import React from "react";

import Grid from "@material-ui/core/Grid";

import { SubtleBadge } from "components/Badge";
import { FormCollapse } from "components/Form";
import { Input, PercentageInput } from "components/Form/FormikControls";
import { InterestSettingForm } from "components/Form/FormikControls/Interest";
import { VendorCommissionBands } from "components/Form/FormikControls/VendorCommissionBands";
import { Row } from "components/Layout";

import { DeploymentPermissions } from "constants/permissions";

import { useHasDeploymentPermission } from "hooks";

import { DeploymentSettingsModalSection } from ".";

export function TradingTermsSection(props) {
  const { sectionHelper } = props;

  const header = (
    <Row>
      <SubtleBadge>Trading Terms &amp; Billing Rates</SubtleBadge>
    </Row>
  );

  const modalSection = DeploymentSettingsModalSection.TRADING_TERMS;
  const [section, setSection] = sectionHelper;

  const isOpen = section === modalSection;
  const onToggle = () => setSection(modalSection);

  const hasInterestFeature = useHasDeploymentPermission(
    DeploymentPermissions.featureInterest,
  );

  return (
    <FormCollapse isOpen={isOpen} onToggle={onToggle} header={header}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Input
            label="Vendor Terms"
            name="vendorTerms"
            type="number"
            afterSymbol="days"
            tooltip="Recipient created invoices will be due this many data after the sale date."
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Input
            label="Buyer Terms"
            name="buyerTerms"
            type="number"
            afterSymbol="days"
            tooltip="Buyer invoices will be due this many data after the sale date."
            required
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <PercentageInput
            label="Default Debtor Insurance"
            name="defaultDebtorInsurance"
            required
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PercentageInput
            label="Default Transit Insurance"
            name="defaultTransitInsurance"
            required
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <PercentageInput
            label="Default Transit Interstate Insurance"
            name="defaultInterstateTransitInsurance"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <VendorCommissionBands tooltip="Enter the default commission rates per sale sub type.  These defaults are applicable to all vendors, unless overridden on a per vendor basis." />
        </Grid>
        {hasInterestFeature && (
          <Grid container item spacing={2} xs={12}>
            <InterestSettingForm />
          </Grid>
        )}
      </Grid>
    </FormCollapse>
  );
}
